import React from 'react';
import PropTypes from 'prop-types';

import BankAccountPresenter, {
  DUBLICATION_STATES,
} from '../../../../../../../../../presenters/BankAccountPresenter';
import Row from '../../../../../../../../../components/Row';
import Column from '../../../../../../../../../components/Column';
import { Label, ErrorFlash } from '../../../../../../../../../components';

const StateChangeForm = (props) => {
  const { bankAccountParams, onStateChange, errors } = props;
  const currentState = BankAccountPresenter.duplicationState(bankAccountParams);
  const statesOptions = Object.keys(DUBLICATION_STATES).map((key) => {
    const duplicationState = DUBLICATION_STATES[key];
    return {
      label: BankAccountPresenter.duplicationStateReadable({
        duplicationState: duplicationState,
      }),
      value: duplicationState,
      disabled:
        BankAccountPresenter.isDisabledDuplicationState(duplicationState),
    };
  });
  const statesOptionsBankAccounts = BankAccountPresenter.bankAccountsWithMask(
    bankAccountParams
  ).map((bankAccount) => {
    return {
      value: BankAccountPresenter.id(bankAccount),
    };
  });

  return (
    <div>
      <ErrorFlash errors={errors} message={errors} />
      <Row>
        <Column className="cashback-field-column">
          <Label attr="duplicationState" text="State" />
          <div>
            <select
              id="duplicationState"
              onChange={onStateChange}
              value={currentState}
            >
              {statesOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </Column>
      </Row>
      {BankAccountPresenter.isDuplicateManually(bankAccountParams) && (
        <Row>
          <Column className="cashback-field-column">
            <Label attr="originalBankAccountId" text="Original Bank Accounts" />
            <div>
              <select id="originalBankAccountId" onChange={onStateChange}>
                <option default value={''}>
                  -- select original account --
                </option>
                {statesOptionsBankAccounts.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.value}
                  </option>
                ))}
              </select>
            </div>
          </Column>
        </Row>
      )}
    </div>
  );
};

StateChangeForm.propTypes = {
  bankAccountParams: BankAccountPresenter.shape().isRequired,
  onStateChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape()),
};

StateChangeForm.defaultProps = {
  errors: null,
};

export default StateChangeForm;
